// GENERATED by :cmp-navigation:generateFeatureDestinations — do not edit.
package cmp.navigation.registry

import androidx.navigation.NavController
import androidx.navigation.NavGraphBuilder
import kpt.feature.alerts.navigation.alertsGraph
import kpt.feature.bills.navigation.billsGraph
import kpt.feature.calculators.navigation.calculatorsGraph
import kpt.feature.crypto.navigation.cryptoGraph
import kpt.feature.currencyrates.navigation.currencyRatesGraph
import kpt.feature.emicalculator.navigation.emiCalculatorDestination
import kpt.feature.loans.navigation.loansGraph
import kpt.feature.macro.navigation.macroGraph
import kpt.feature.rates.navigation.ratesGraph
import kpt.feature.watchlist.navigation.watchlistGraph

/** Every `@FeatureDestination` top-level entry, derived from source. */
public val GeneratedFeatureDestinations: NavGraphBuilder.(NavController) -> Unit = { navController ->
    alertsGraph(navController)
    billsGraph(navController)
    calculatorsGraph(navController)
    cryptoGraph(navController)
    currencyRatesGraph(navController)
    emiCalculatorDestination(navController)
    loansGraph(navController)
    macroGraph(navController)
    ratesGraph(navController)
    watchlistGraph(navController)
}
